import { useFeatureToggle } from '@bizzabo/feature-toggle-client';

const useMessagesEnabled = () => {
    return useFeatureToggle('venue-messages', true);
};

export default useMessagesEnabled;
